"use strict";
var DOCUMENT_TYPES = require('./documentTypes');
var DOCUMENT_STATUS = require('./documentStatus');
var EVENTS = require('./events');
var MEMBER_TYPES = require('./memberTypes');
var SHAREHOLDER = require('./shareholder');
var IDENTITY_STATUS = require('./identityStatus');
var DIRECTOR = require('./director');
module.exports = {
    DOCUMENT_TYPES: DOCUMENT_TYPES,
    DOCUMENT_STATUS: DOCUMENT_STATUS,
    DOCUMENT_CLASSIFICATION: {
        INDIVIDUAL_IDENTIFICATION: 'individual_identification',
    },
    EVENTS: EVENTS,
    MEMBER_TYPES: MEMBER_TYPES,
    SHAREHOLDER: SHAREHOLDER,
    DIRECTOR: DIRECTOR,
    IDENTITY_STATUS: IDENTITY_STATUS,
    MEMBER_IDENTITY_KYC_STATUS: {
        APPROVED: 'approved',
        DISAPPROVED: 'disapproved',
        PENDING: 'pending',
    },
    COMPANY_REGISTER_FK_TYPE: {
        COMPANY_ENTITY_USER: 'company_entity_user',
        MEMBER_IDENTITY: 'member_identity',
    },
};
